import pluginPkg from '../../package.json';
import Initializer from './components/Initializer';
import pluginId from './pluginId';
const name = pluginPkg.strapi.name;
export default {
  register(app) {
    app.registerPlugin({
      id: pluginId,
      initializer: Initializer,
      isReady: false,
      name
    });
  }
};